import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import './Navbar_NL_01.css';

import { language } from '../WEBContent/Language';

import {
    //repo_img_link,
    set_language,
    content_language,
    translate,
    compose_link_nl
} from '../../../Utils';

//import AssecImage from "../ASSEC_Image/ImageNL"

import * as Hosts from "../../../Hosts";

const Navbar = (props) => {

    //const { pathname } = useLocation();

	const [, set_dados] = useState(null)
    const dados_config = useRef(null);
	const nl_entity_uid = useRef('');

    const data_interface = {
        id: '',
        info: {},
        content: {
            childs: []
        }
    }
    const navbar = useRef(data_interface);

    const [pag_logo, set_pag_logo] = useState('');
    //const [uid, set_uid] = useState('');

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [lang_id, set_lang_id] = useState('1');

    const [isloading, setLoading] = useState(true);

    const [page_location, set_page_location] = useState(useLocation().pathname.split('/').pop());
    const [link_see_online, set_link_see_online] = useState(useLocation().pathname.split('/').pop());

    const location = useLocation().pathname;

    useEffect(() => {

        function get_image_logo(el, type) {
    
            let result = ''
    
            if(parseInt(lang_id) === 1) {
    
                if(el.content !== undefined && el.content[0].logo !== undefined && el.content[0].logo !== null) {
    
                    if(type === 'url') {
                    result = el.content[0].logo.url
                    }
    
                }
    
            }
    
            return result
        }

        //console.log('props', props)

        if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
            set_dados(navbar.current = props.dados_navbar)
        }

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_pag_logo(get_image_logo(props.dados_config, 'url'))
            set_dados(dados_config.current = props.dados_config)
            
            set_link_see_online(Hosts.WEB_SITE_DOMAIN.trim() + '' + Hosts.APPLICATION_URL.trim() + 'nl/' +  props.dados_config.info.uniqid)

            //console.log('link', Hosts.WEB_SITE_DOMAIN.trim() + '' + Hosts.APPLICATION_URL.trim() + 'nl/' +  props.dados_config.info.uniqid)

            setLoading(false)
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                set_lang_id(el.id)
                }
            })
        }

        if(location.includes('/nl/')) {

            let aux_path_params = location.split('/')
            
            if(aux_path_params[3] !== null && aux_path_params[3] !== '') {

                console.log('aux_path_params', aux_path_params)

                //let type = aux_path_params[1]
                //let nl_uid = aux_path_params[2]
                //let entity_uid = aux_path_params[3]
                set_dados(nl_entity_uid.current = aux_path_params[3])

            }

        }

        if(page_location === 'all') {
            let aux = location.split('/all');
            set_page_location(aux[0].split('/').pop())
        }

    }, [props, location, page_location, lang, lang_id])

    return (
        isloading ?
          null
        :
            <table cellPadding="0" cellSpacing="0" align="center" className="es-content nvnl" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important' }} >
                <tbody>
                    <tr style={{borderCollapse: 'collapse'}} >
                        <td>
                            <table cellPadding="0" cellSpacing="0" align="center" className="es-content" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important' }} >
                                <tbody>
                                    <tr style={{borderCollapse: 'collapse'}} >
                                        <td bgcolor="#f7f7f7" align="center" className="es-adaptive" style={{padding: '0', margin: '0', backgroundColor: '#f7f7f7' }} >
                                            <table cellSpacing="0" cellPadding="0" align="center" className="es-content-body" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', backgroundColor: 'transparent', width: '600px' }} role="none">
                                                <tbody>
                                                    <tr style={{borderCollapse: 'collapse'}} >
                                                        <td align="left" style={{ padding: '4px', margin: '0' }} >
                                                            <table style={{ width: '580px' }} >
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ width: '580px' }} valign="top">
                                                                            <table cellSpacing="0" cellPadding="0" align="right" className="es-right" role="none" style={{msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', float: 'right' }} >
                                                                                <tbody>
                                                                                    <tr style={{borderCollapse: 'collapse' }}>
                                                                                        <td align="left" style={{padding: '0', margin: '0', width: '580px' }} >
                                                                                            <table width="100%" cellSpacing="0" cellPadding="0" role="presentation" style={{msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }} >
                                                                                                <tbody>
                                                                                                    <tr style={{borderCollapse: 'collapse' }}>
                                                                                                        <td align="right" className="es-infoblock" style={{ padding: '0', margin: '0' }}>
                                                                                                            <p className="es-m-txt-c" style={{margin: '0', msoLineHeightRule: 'exactly', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", lineHeight: '18px', letterSpacing: '0', color: '#b1b1b1', fontSize: '12px' }} >
                                                                                                                {language[lang].nl_problems}&nbsp;
                                                                                                                <a href={link_see_online} target="_blank" className="view" style={{msoLineHeightRule: 'exactly', textDecoration: 'underline', color: '#b1b1b1', fontSize: '12px', marginLeft: '5px' }} >
                                                                                                                    {language[lang].nl_see_online}
                                                                                                                </a>
                                                                                                            </p>
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table cellSpacing="0" cellPadding="0" align="center" className="es-header" role="none" style={{msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', width: '100%', tableLayout: 'fixed !important', backgroundColor: 'transparent', backgroundRepeat: 'repeat', backgroundPosition: 'center top' }} >
                                <tbody>
                                    <tr style={{ borderCollapse: 'collapse' }}>
                                        <td align="center" className="es-adaptive" style={{padding: '0', margin: '0' }} >
                                            <table cellSpacing="0" cellPadding="0" align="center" className="es-header-body" role="none" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', backgroundColor: 'transparent', width: '600px' }} >
                                                <tbody>
                                                    <tr style={{ borderCollapse: 'collapse' }}>
                                                        <td align="left" bgcolor="#ffffff" style={{ padding:'0', margin: '0', backgroundColor: '#ffffff' }}>
                                                            <table style={{ width: '600px' }} cellPadding="0" cellSpacing="0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ width: '220px' }} valign="top">
                                                                            <table cellSpacing="0" cellPadding="0" align="left" className="es-left" role="none" style={{msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px', float: 'left' }}>
                                                                                <tbody>
                                                                                    <tr style={{ borderCollapse: 'collapse' }}>
                                                                                        <td valign="top" align="center" className="es-m-p0r es-m-p20b" style={{padding: '0', margin: '0', width:'220px' }} >
                                                                                            <table width="100%" cellSpacing="0" cellPadding="0" role="presentation" style={{msoTableLspace: '0pt', msoTtableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }} >
                                                                                                <tbody>
                                                                                                    <tr style={{ borderCollapse: 'collapse' }}>
                                                                                                        <td align="center" style={{paddingLeft: '10px', paddingTop: '25px', paddingBottom: '25px', margin: '0', fontSize: '0px' }}>
                                                                                                            {
                                                                                                            dados_config.current.content[0].contacts.link !== '' ?
                                                                                                                <a href={compose_link_nl(dados_config.current.info.uniqid, 'fv', 0, '*')} target="_blank">
                                                                                                                    <img src={pag_logo} alt={Hosts.webSiteTitle} title={Hosts.webSiteTitle} width="162" className="adapt-img" style={{display: 'block', fontSize: '14px', border: '0', outline: 'none', textDecoration: 'none' }} />
                                                                                                                </a>
                                                                                                            :
                                                                                                                <img src={pag_logo} alt={Hosts.webSiteTitle} title={Hosts.webSiteTitle} width="162" className="adapt-img" style={{display: 'block', fontSize: '14px', border: '0', outline: 'none', textDecoration: 'none' }} />
                                                                                                            }
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                        <td style={{ width: '30px' }} ></td>
                                                                        <td style={{ width: '350px', valign: "top" }} >
                                                                            <table cellSpacing="0" cellPadding="0" align="right" role="none" style={{ msotablelspace: '0pt', msotablerspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }} >
                                                                                <tbody>
                                                                                    <tr style={{ borderCollapse: 'collapse' }}>
                                                                                        <td align="left" style={{ padding: '0', margin: '0', width: '350px', paddingRight:'30px'}} >
                                                                                            <table width="100%" cellSpacing="0" cellPadding="0" role="presentation" style={{ msoTableLspace: '0pt', msoTableRspace: '0pt', borderCollapse: 'collapse', borderSpacing: '0px' }} >
                                                                                                <tbody>
                                                                                                    <tr style={{ borderCollapse: 'collapse' }}>
                                                                                                        <td align="right" style={{ padding: '0', margin: '0', paddingTop: '0px' }}>
                                                                                                        <h3 style={{margin: '0', fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'", msoLineHeightRule: 'exactly', letterSpacing: '0', fontSize: '16px', fontStyle: 'normal', fontWeight: '700', lineHeight: '22px', color: '#343a40', textWrap: 'balance'}} >
                                                                                                                {translate(dados_config.current?.content[0]?.subtitle, 'pt')}
                                                                                                            </h3>
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
    )
};
export default Navbar;